import axios from 'axios';

export const baseHttpOptions = {
  baseURL: '/api/v2',
  withCredentials: true,
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
  headers: {
    'Accept': 'application/json',
  },
};

export const API = axios.create({
  ...baseHttpOptions,
});

